<template>
  <div data-testid="data-table-new" class="">
    <div data-testid="data-table-new__toolbar" class="d-flex align-center gap-2">
      <!-- <span data-testid="data-table-new__selected-count" v-if="selectItem.length > 0">{{ selectItem.length }} <span>item(s) selected</span></span>
      <v-btn data-testid="data-table-new__clear-selections-btn" v-if="selectItem.length > 0" class="secondaryBtn" @click="
        selectItem=[],selectedItem=[];
      showFilter[index] = false;
      ">
        <span>{{ 'Clear Selections' }}</span>
      </v-btn> -->
      <v-spacer></v-spacer>
      <template class="display-ib">
        <slot name="additionalinfo" :value="selectItem" :selected="selectItem" :selectall="selectAll"></slot>
      </template>
      <div :style="showFilter.filter(x => x === true).length > 0 ? {} : { visibility: 'hidden', pointerEvents: 'none' }">
        <v-tooltip data-testid="data-table-new__reset-filters-tooltip" bottom content-class="tooltip-bottom">
          <template v-slot:activator="{ on, attrs }">
            <base-button data-testid="data-table-new__reset-filters-btn" icon-style v-bind="attrs" v-on="on" color="" @click="resetFilters()">
              <v-icon data-testid="data-table-new__reset-filters-icon">mdi-filter-remove</v-icon>
            </base-button>
          </template>
          <span>{{ 'Reset Filters' }}</span>
        </v-tooltip>
      </div>
      <template v-if="selectHeader.length > 0 && !hideColumnSelector">
        <v-menu data-testid="data-table-new__columns-menu" offset-y transition="slide-y-transition" :close-on-content-click="false" scrollable max-height="250"
          max-width="300">
          <template v-slot:activator="{ on: menu, attrs }">
            <v-tooltip data-testid="data-table-new__columns-tooltip" left  :content-class="items.length < perpage ? 'tooltip-left' : 'tooltip-left'"> 
              <template v-slot:activator="{ on: tooltip }">
                <base-button data-testid="data-table-new__columns-btn" class="mx-0 px-0" icon-style v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                  <v-icon data-testid="data-table-new__columns-icon">mdi-format-list-checks</v-icon>
                </base-button>
              </template>
              <span>Select Columns</span>
            </v-tooltip>
          </template>
          <div class="pt-2 white" data-testid="data-table-new__columns-list">
            <div class="pa-1">
              <v-checkbox data-testid="data-table-new__column-checkbox" v-for="(option, k) in selectHeader" :key="k" class="pa-2 mt-0 pt-0" dense multiple scrollable
                 :value="option.value" hide-details v-model="visibleheader" >
              <template v-slot:label>
                <span>{{ option.text }}</span>
              </template></v-checkbox>
            </div>
          </div>
        </v-menu>
      </template>
    </div>
    <div data-testid="data-table-new__table-wrapper" class="rounded-lg overflow-hidden">
      <v-simple-table data-testid="data-table-new__table" dense fixed-header :class="`${(bgColor)?'FC-Table':'v-table-color'} datatable-standard rounded-lg`">
        <template>
          <thead data-testid="data-table-new__thead" class="tableHeaderBg">
            <tr data-testid="data-table-new__header-row">
              <th data-testid="data-table-new__header-selectall" v-if="multiselectkey" class="" style="width: 50px; min-width: 50px; max-width: 50px;">
                  <v-checkbox
                    data-testid="data-table-new__selectall-checkbox"
                    dense
                    class="ma-0 py-1"
                    hide-details
                    v-model="selectAll"
                    @click="select()"
                    :disabled="disableCheckbox"
                  ></v-checkbox>
                </th>
              <template v-for="(header, index) in headers">
                <th data-testid="data-table-new__header-cell" v-if="(header.lock ?? true) ||
                  visibleheader.indexOf(header.value) > -1
                  " :key="header.value" :sortable="header.sortable" :class="[header.alignment, header.align ? `text-${header.align}` : '']"
                  :style="getColumnStyle(header)"
                  :colspan="header.colspan || 0">
                  <div :class="`d-flex align-center ${ (header.alignment === 'text-center' || header.align === 'center') ? 'justify-center' : (header.alignment === 'text-right' || header.align === 'right' || header.align === 'end') ? 'justify-end' : 'justify-space-between' }`">
                    <span>{{ header.text }}</span>
                    <div class="d-inline-block" v-if="header.sortable || header.filterable">
                      <div class="d-flex">
                        <span data-testid="data-table-new__sort-wrapper" v-if="header.sortable" @click="sortData(header)">
                          <base-button data-testid="data-table-new__sort-btn-asc" icon-style small v-if="!sortDesc && sortKey === header.value">
                            <img data-testid="data-table-new__filter-icon-empty" v-if="!showFilter[index]" src="/img/icons/ShortIcon.svg" alt="filter" height="16" width="16" />
                          </base-button>
                          <base-button data-testid="data-table-new__sort-btn-desc" icon-style small v-else-if="sortKey === header.value">
                            <img data-testid="data-table-new__filter-icon-empty" v-if="!showFilter[index]" src="/img/icons/ShortIcon.svg" alt="filter" height="16" width="16" />
                          </base-button>
                          <base-button data-testid="data-table-new__sort-btn-none" icon-style small v-else class="grey--text text--lighten-1">
                           <img data-testid="data-table-new__filter-icon-empty" v-if="!showFilter[index]" src="/img/icons/ShortIcon.svg" alt="filter" height="16" width="16" />
                          </base-button>
                        </span>
                        <span>
                          <v-menu data-testid="data-table-new__filter-menu" v-if="header.filterable" max-width="300" offset-y :close-on-content-click="false"
                            :key="index" rounded="lg" v-model="menuOpen[header.value]" :disabled="disableFilters">
                            <template v-slot:activator="{ on, attrs }">
                              <base-button data-testid="data-table-new__filter-btn" icon-style small v-bind="attrs" v-on="disableFilters ? {} : on" :style="disableFilters ? { pointerEvents: 'none' } : {}" @click="!disableFilters && (setHeader(header.value), onMenuOpen(header.value))">
                                <v-progress-circular v-if="disableFilters" indeterminate size="14" width="2" color="grey" data-testid="data-table-new__filter-loading"></v-progress-circular>
                                <v-icon data-testid="data-table-new__filter-icon-active" small v-else-if="showFilter[index] || (selectedFilterItems[header.value] && selectedFilterItems[header.value].length > 0)" color="primary">mdi-filter</v-icon>
                                <img data-testid="data-table-new__filter-icon-empty" v-else src="/img/icons/FilterIcon.svg" alt="filter" height="16" width="16" />
                              </base-button>
                            </template>
                            <v-card data-testid="data-table-new__filter-card" max-height="400">
                              <v-card
                                  data-testid="column-filter__header-card"
                                  flat
                                >
                                  <v-card-title
                                    data-testid="column-filter__header"
                                    class="px-3 py-2 d-flex align-center justify-space-between tableHeaderBg"
                                  >
                                    <div
                                      data-testid="column-filter__header-content"
                                      class="d-flex align-center"
                                    >
                                      <span
                                        data-testid="column-filter__title-text"
                                        class="font-weight-bold"
                                      >
                                        {{ header.text }}
                                      </span>
                                    </div>
                                    <base-button
                                      data-testid="column-filter__close-btn"
                                      icon-style
                                      small
                                      @click="menuOpen[header.value] = false"
                                    >
                                      <v-icon data-testid="column-filter__close-icon">
                                        mdi-close
                                      </v-icon>
                                    </base-button>
                                  </v-card-title>
                                  <v-divider data-testid="column-filter__header-divider"></v-divider>
                                </v-card>
                              <v-card-text class="pa-0">
                                <lb-string data-testid="data-table-new__filter-search" v-if="!header.disableFilterSearch" class="px-2 pt-2 mt-0" label="Search" v-model="seachFilter[header.value]"
                                  hidedetails />
                              </v-card-text>
                              
                              <v-card-text class="pa-0 ma-0 pt-2 scroll">
                                <FilterSelectAllCheckbox
                                  v-if="getFilterList(seachFilter[header.value], header.value).length > 0"
                                  test-id="data-table-new__filter-select-all"
                                  :options="getFilterList(seachFilter[header.value], header.value)"
                                  :value="tempSelectedFilterItems[header.value] || []"
                                  @input="$set(tempSelectedFilterItems, header.value, $event)"
                                />
                                <v-checkbox data-testid="data-table-new__filter-option-checkbox" v-for="(option) in getFilterList(
                                  seachFilter[header.value],
                                  header.value
                                ).slice(0, getFilterLimit(header.value))" :key="option.value" class="pa-2 mt-0 pt-0" dense multiple
                                  scrollable :label="option.name" :value="option.value" hide-details
                                  v-model="tempSelectedFilterItems[header.value]" >
                                <template v-slot:label>
                                    <span class="font-size-md noTransform">{{ option.name }}</span>
                                  </template></v-checkbox>
                                <div
                                  data-testid="data-table-new__filter-empty"
                                  v-if="getFilterList(seachFilter[header.value], header.value).length === 0"
                                  class="text-center py-4 grey--text"
                                >
                                  No results found
                                </div>
                                <div
                                  data-testid="data-table-new__filter-option-more"
                                  v-if="getFilterList(
                                    seachFilter[header.value],
                                    header.value
                                  ).length > getFilterLimit(header.value)"
                                  class="mx-2 my-1 primary--text caption cursor-pointer d-flex align-center"
                                  role="button"
                                  tabindex="0"
                                  @click="showMoreFilterItems(header.value)"
                                  @keydown.enter.prevent="showMoreFilterItems(header.value)"
                                  @keydown.space.prevent="showMoreFilterItems(header.value)"
                                >
                                  <v-icon small color="primary" class="mr-1">mdi-chevron-down</v-icon>
                                  Show {{ getFilterList(seachFilter[header.value], header.value).length - getFilterLimit(header.value) }} more
                                </div>
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <base-button  @click="clearTempFilter(header.value)" secondary>Clear</base-button>
                                <v-spacer></v-spacer>
                                <base-button primary  @click="applyFilter(header.value)">Apply</base-button>
                              </v-card-actions>
                            </v-card>
                          </v-menu>
                        </span>
                      </div>
                    </div>
                  </div>
                </th>
              </template>
            </tr>
          </thead>
          <tbody data-testid="data-table-new__tbody">
            <template v-for="(item, index) in pageItems">
              <tr data-testid="data-table-new__row" :key="(multiselectkey && item[multiselectkey]) || item._id || item.id || index"
                @click.stop="((typeof item.__click === 'string') ? $nova.gotoLink({ path: item.__click }) : ((typeof item.__click === 'function') ? item.__click(item) : null))"
                :class="[{'font-weight-bold': item.cl_type && item.cl_type.toLowerCase() === 'total'}, typeof itemClass === 'function' ? itemClass(item) : itemClass]">
                <!-- <td>
                </td> -->
                <td data-testid="data-table-new__cell-select" v-if="multiselectkey"
                  :class="[item.status === false ? 'border-left-error' : 'border-left-transparent']" @click.stop>
                  <v-checkbox v-if="item._selectable !== false" data-testid="data-table-new__row-checkbox" dense class="ma-0 py-1" hide-details :value="item[multiselectkey]" v-model="selectItem"
                    @click.stop="addItemToSelect(item)" :disabled="disableCheckbox"></v-checkbox>
                </td>
                <template v-for="(v, k) in headers">
                  <td data-testid="data-table-new__cell" v-if="(v.lock ?? true) || visibleheader.indexOf(v.value) > -1" :key="k"
                    :class="[v.alignment, item.__click ? 'cursor-pointer' : '', v.cellClass || '']"
                    :style="getColumnStyle(v)">
                    <div>
                      <div v-if="enableslot.indexOf(v.value) > -1">
                        <slot :name="`item.${v.value}`" :item="item" :index="index" :page="page" :perpage="perpage">
                          <slot :name="v.value" :item="item" :index="index" :page="page" :perpage="perpage"></slot>
                        </slot>
                      </div>
                      <div v-else>
                        <span data-testid="data-table-new__cell-date" v-if="v.datatype === 'date'">
                          {{ $nova.formatDate(item[v.value]) }}
                        </span>
                        <span data-testid="data-table-new__cell-number" v-else-if="v.datatype === 'number'">
                          {{ $nova.formatNumber(item[v.value]) }}
                        </span>
                        <span data-testid="data-table-new__cell-array" v-else-if="v.datatype === 'array'">
                          <div v-for="(value, key) in item[v.value]" :key="key">
                            <v-chip data-testid="data-table-new__cell-array-chip" small> <span>{{ value }}</span></v-chip>
                          </div>
                        </span>
                        <span data-testid="data-table-new__cell-object" v-else-if="v.datatype === 'object'">
                          <div v-for="(value, key) in item[v.value]" :key="key">
                            <v-chip data-testid="data-table-new__cell-object-chip" small> <span>{{ value }}</span></v-chip>
                          </div>
                        </span>
                        <span data-testid="data-table-new__cell-value" v-else>
                          {{ item[v.value] }}
                        </span>
                      </div>
                    </div>
                  </td>
                </template>
              </tr>
              <template v-if="$scopedSlots['row-after']">
                <slot name="row-after" :item="item"></slot>
              </template>
            </template>
            <template v-if="pageItems.length === 0 && !loading">
              <tr data-testid="data-table-new__no-data-row">
                <td :colspan="visibleHeadersCount" class="text-center pa-2" data-testid="data-table-new__no-data-cell">
                  <slot name="no-data">
                    <div class="grey--text pa-4" data-testid="data-table-new__no-data-message">No data available</div>
                  </slot>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <!-- Inline Pagination style when paginationOverAll is true -->
    <Pagination
      v-if="pagecount > 1 && !hideDefaultFooter && !hidePagination && paginationOverAll"
      :list="finalItems"
      :itemsperpage="perpage"
      :lengthOverride="pagecount"
      :hideOnSinglePage="true"
      :inline="paginationOverAllinline"
      v-model="page"
      @input="loadNextPageCheckbox"
      data-testid="data-table-new__pagination-overall"
    />
    <!-- Default v-pagination style when paginationOverAll is false -->
    <div class="d-flex justify-end pt-2" v-if="pagecount > 1 && !hideDefaultFooter && !hidePagination && !paginationOverAll">
      <v-pagination
        v-model="page"
        :length="pagecount"
        :total-visible="7"
        @input="loadNextPageCheckbox"
        data-testid="data-table-new__pagination"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
import varianceAnalysisConstants from '@/modules/varianceanalysis/constants.js';
import Pagination from '@/views/common/Pagination.vue';
import FilterSelectAllCheckbox from '@/views/common/FilterSelectAllCheckbox.vue';

export default {
  components: { Pagination, FilterSelectAllCheckbox },
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    multiselectkey: {
      type: String,
      default: "",
    },
    disableCheckbox: {
      type: Boolean,
      default: false,
    },
    slots: {
      type: Array,
      required: false,
    },
    group: {
      type: String,
      default: null,
    },
    enableslot: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: true,
    },
    selecteditems: {
      type: Array,
      default: () => []
    },
    bgColor:{
      type: Boolean,
      default:false
    },
    perpage:{
      type:Number,
      default:25,
    },
    hideColumnSelector: {
      type: Boolean,
      default: false
    },
    hideDefaultFooter: {
      type: Boolean,
      default: false
    },
    hidePagination: {
      type: Boolean,
      default: false
    },
    paginationOverAll: {
      type: Boolean,
      default: false
    },
    paginationOverAllinline: {
      type: Boolean,
      default: true
    },
    bypassFiltering: {
      type: Boolean,
      default: false
    },
    /**
     * When true, pagination is handled server-side.
     * - Items are rendered as-is (no slicing).
     * - Page count is derived from serverTotalCount.
     * - Page changes emit 'loadNextPage' so the parent can re-fetch.
     */
    serverSidePagination: {
      type: Boolean,
      default: false
    },
    /**
     * Total number of records on the server (used only when serverSidePagination is true).
     */
    serverTotalCount: {
      type: Number,
      default: 0
    },
    /**
     * Current page index (0-based) controlled by the parent.
     * Used to sync the internal page state in server-side pagination mode.
     */
    currentPage: {
      type: Number,
      default: 0
    },
    itemClass: {
      type: [String, Function, Object],
      default: null
    },
    /**
     * When true, filter buttons in headers are disabled (unclickable).
     * Useful to prevent filter interaction while data is loading.
     */
    disableFilters: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sortKey: "",
      sortDesc: false,
      filterValue: {},
      filterItems: {},
      showFilter: [],
      visibleheader: [],
      seachFilter: {},
      finalyHead: null,
      selectAll: false,
      selectItem: [],
      selectedItem: [],
      newselectedItem: [],
      page: 1,
      pagecount: 1,
      total: 0,
      selectedHeader:"",
      selectedFilterItems:{},
      tempSelectedFilterItems: {},
      menuOpen: {},
      filterDisplayLimit: {},
      defaultFilterLimit: 25,
      tab: null,
      tableHeight:''
    };
  },
  created() {
    // Initialize non-reactive guard flag for suppressing duplicate loadNextPage
    // emits during prop-driven page sync. Uses _ prefix intentionally as a
    // non-reactive instance property (Vue 2 reserves _ in data()).
    this._isPageSyncing = false;
    this.tableHeight = window.innerHeight - 200;
    if (this.loading === false) {
      this.resetFilters();
      this.selectItem = this.selecteditems
      this.selectedItem = this.selecteditems
    }
  },
  activated() {
    if (this.loading === false) {
      if (!this.serverSidePagination) {
        this.resetFilters();
      }
    }
  },
  beforeDestroy() {
    if (!this.serverSidePagination) {
      this.resetFilters();
    }
    this.selectAll = false;
    this.selectItem = [];
    this.selectedItem = [];
  },
  computed: {
    visibleHeadersCount() {
      let count = this.headers.filter((header) => {
        return (header.lock ?? true) || this.visibleheader.indexOf(header.value) > -1;
      }).length;
      if (this.multiselectkey) {
        count += 1;
      }
      return count;
    },
    selectHeader() {
      return this.headers.filter((x) => {
        if (x.lock !== undefined && !x.lock) {
          return {
            value: x.value,
            text: x.text,
          };
        }
      });
    },
    pageItems() {
      // Server-side pagination: backend already returns the correct page slice.
      // pagecount is managed by the serverTotalCount watcher — do NOT call storeTotal here.
      if (this.serverSidePagination) {
        return this.items || [];
      }
      this.storeTotal((this.finalItems || []).length)
      if (this.hideDefaultFooter) return this.finalItems;
      return this.finalItems.slice((this.page - 1) * this.perpage, (this.page) * this.perpage);
    },
    finalItems() {
      // In server-side pagination mode, always bypass client-side filtering/sorting
      // and avoid mutating pagination state (page, pagecount, total, indexno).
      if (this.serverSidePagination) {
        return this.items || [];
      }
      if (this.bypassFiltering) {
        // In server-side mode, skip storeTotal to avoid overriding the watcher-managed pagecount
        if (!this.serverSidePagination) {
          this.storeTotal((this.items || []).length);
        }
        return this.items || [];
      }
      let itemFinal = "";
      this.resetPage();
      if (Object.keys(this.selectedFilterItems).length === 0) {
        itemFinal = this.items;
      }
      itemFinal = (this.items || []).filter((item) => {
        return this.headers.every((header) => {
          const value = header.value;
          const data = item[value];
          const search = this.selectedFilterItems[value];
          if (!search) {
            return true;
          } else if (Array.isArray(data)) {
            return this.includesValue(data, search);
          } else if (typeof data === "object") {
            return this.jsonIncludesValue(header.filterkey, data, search);
          } else return this.includesValue(data, search);
        });
      });
      const items = itemFinal;
      if (this.sortKey) {
        items.sort((a, b) => {
          const header = this.headers.find(h => h?.value === this.sortKey);
          const modifier = this.sortDesc ? -1 : 1;
          let valueA = a[this.sortKey];
          let valueB = b[this.sortKey];
          // handle financial numbers type for sorting like (1,234)
          if (header && header.dataType === varianceAnalysisConstants.CLIENT_SALES_BREAKDOWN.HEADER_DATA_TYPES.FINANCIAL_NUMBER) {
            const numberA = this.parseFinancialNumber(valueA);
            const numberB = this.parseFinancialNumber(valueB);
            return (numberA - numberB) * modifier;
          }
          // Handle null/undefined
          if (valueA == null && valueB == null) return 0;
          if (valueA == null) return 1;
          if (valueB == null) return -1;

          // Try number comparison
          const numberA = Number(valueA);
          const numberB = Number(valueB);
          const isNumA = !isNaN(numberA) && valueA !== "" && valueA !== null;
          const isNumB = !isNaN(numberB) && valueB !== "" && valueB !== null;
          if (isNumA && isNumB) {
            return (numberA - numberB) * modifier;
          }

          // Try date comparison
          const dateA = new Date(valueA);
          const dateB = new Date(valueB);
          if (!isNaN(dateA) && !isNaN(dateB)) {
            if (dateA < dateB) return -1 * modifier;
            if (dateA > dateB) return 1 * modifier;
            return 0;
          }

          // Default: string compare
          valueA = valueA.toString().toLowerCase();
          valueB = valueB.toString().toLowerCase();
          if (valueA < valueB) return -1 * modifier;
          if (valueA > valueB) return 1 * modifier;
          return 0;
        });
      }
      for (let i = 0; i < items.length; i++) {
        const el = items[i];
        el.indexno = i + 1;
      }
      this.storeTotal((items || []).length);
      //this.resetPage();
      return items;
    },
  },
  methods: {
    resetPage() {
      this.page = 1;
    },
    storeTotal(len) {
      this.total = len;
      //this.selectItem = this.selecteditems || [];
      // this.selectAll = false;
      this.pagecount = Math.ceil(this.total / this.perpage);
    },
   parseFinancialNumber(str) {
      if (typeof str !== 'string') str = String(str);
      let isNegative = str.includes('(') && str.includes(')');
      let cleaned = str.replace(/[^0-9.]+/g, '');
      let num = parseFloat(cleaned) || 0;
      return isNegative ? -num : num;
    },
    onMenuOpen(key) {
      this.$emit('filter-menu-open', key);
      // Ensure we initialize with currently applied filters for this column
      const current = this.selectedFilterItems[key];
      this.$set(this.tempSelectedFilterItems, key, current ? [...current] : []);
      // Reset display limit to default when menu opens
      this.$set(this.filterDisplayLimit, key, this.defaultFilterLimit);
      this.$set(this.seachFilter, key, '');
    },
    /**
     * Sets filter items for a specific column externally (e.g. from parent via $refs).
     * @param {string} key - The column header value
     * @param {Array} items - Array of { name, value } objects
     */
    setExternalFilterItems(key, items) {
      this.$set(this.filterItems, key, items || []);
    },
    /**
     * Returns the current display limit for a column's filter dropdown.
     * @param {string} key - The column header value
     * @returns {number} Number of items to display
     */
    getFilterLimit(key) {
      return this.filterDisplayLimit[key] || this.defaultFilterLimit;
    },
    /**
     * Increases the display limit for a column's filter dropdown to show more items.
     * Adds another batch of items (default batch size) or shows all remaining.
     * @param {string} key - The column header value
     */
    showMoreFilterItems(key) {
      const currentLimit = this.getFilterLimit(key);
      const totalItems = this.getFilterList(this.seachFilter[key], key).length;
      // Show all remaining items on click
      const newLimit = Math.min(currentLimit + this.defaultFilterLimit, totalItems);
      this.$set(this.filterDisplayLimit, key, newLimit);
    },
    applyFilter(key) {
      const currentTemp = this.tempSelectedFilterItems[key] || [];
      this.$set(this.selectedFilterItems, key, [...currentTemp]);
      this.$set(this.seachFilter, key, '');
      this.$set(this.menuOpen, key, false);
      this.applyFilters();
    },
    clearTempFilter(key) {
      this.$set(this.tempSelectedFilterItems, key, []);
      this.$set(this.selectedFilterItems, key, []);
      this.$set(this.seachFilter, key, '');
      this.$set(this.menuOpen, key, false);
      this.applyFilters();
    },
    getFilterList(search = "", key = "") {
      const items = this.filterItems[key] || [];
      if (!search) return items;
      const searchLower = search.toLowerCase();
      return items.filter(x => (x.name || "").toLowerCase().includes(searchLower));
    },
    headerFilter() {
      this.filterItems = {};
      for (const head of this.headers) {
        if (head.filterable === true) {
          this.filterItems[head.value] = this.getUniqueColumnValues(head);
        }
        if (head.defaultsort && head.defaultsort === 'desc') {
          this.sortKey = head.value;
          this.sortDesc = true;
        }
      }
      if (this.sortDesc === true) {
        this.sortData();
      }
    },
    populateVisible() {
      this.visibleheader = [];
      for (const k in this.headers) {
        if (Object.hasOwnProperty.call(this.headers, k)) {
          const el = this.headers[k];
          if (!el.lock && el.visible) this.visibleheader.push(el.value);
        }
      }
    },
    includesValue(value, search) {
      if (search.length > 0) {
        if (search instanceof Array) {
          for (const arrayItem of search) {
            if (typeof arrayItem === "string") {
              if (value instanceof Array) {
                return this.hasMatchingValue(value, search);
              } else if (typeof value === "number") {
                let nvalue = value.toString();
                return search.includes(nvalue);
              } else {
                let nsearch = search.map((x) => x.toLowerCase());
                let nvalue = (value || "").toLowerCase();
                return nsearch.includes(nvalue);
              }
            } else {
              return search.includes(value);
            }
          }
        }
      }
      return true;
    },
    jsonIncludesValue(filterKey, value, search) {
      if (value && typeof value === "object") {
        if (Object.prototype.hasOwnProperty.call(value, filterKey)) {
          return this.includesValue(value[filterKey], search);
        }
        return Object.values(value).some((val) =>
          this.includesValue(val, search)
        );
      }
      return false;
    },
    hasMatchingValue(arr1, arr2) {
      for (let i = 0; i < arr1.length; i++) {
        if (arr2.includes(arr1[i].toString())) {
          return true;
        }
      }
      return false;
    },
    applyFilters() {
      this.showFilter = this.headers.map((header) => {
        return (
          header.filterable &&
          this.selectedFilterItems[header.value] &&
          (this.selectedFilterItems[header.value] || []).length > 0
        );
      });
      this.$emit('update:filters', this.selectedFilterItems);
    },
    getUniqueColumnValues(header) {
      let column = header.value;
      let filterkey = header.filterkey;
      if (Array.isArray(header.filterList)) {
        let filterOption = [];
        header.filterList.forEach((val) => {
          if (typeof val === "object" && !(val instanceof Array)) {
            return filterOption.push(val);
          } else {
            let temArr = [];
            for (const item of header.filterList) {
              temArr.push({
                name: item,
                value: item,
              });
            }
            return (filterOption = temArr);
          }
        });
        return filterOption;
      } else {
        let values = new Set();
        (this.items || []).forEach((item) => {
          const value = item[column];
          if (Array.isArray(value)) {
            value.forEach((val) => {
              if (typeof val === "object" && !(val instanceof Array)) {
                Object.keys(val).forEach((key) => values.add(key));
                values.add(String(val[filterkey] || val));
              } else values.add(String(val));
            });
          } else if (typeof value === "object") {
            if (filterkey) {
              values.add(String(value[filterkey] || value));
            } else {
              Object.keys(value).forEach((key) =>
                values.add(String(value[key]))
              );
              //values.add(String(value[filterkey] || value));
            }
          } else {
            values.add(String(value));
          }
        });
        let temArr = [];
        for (const item of Array.from(values)) {
          temArr.push({
            name: item,
            value: item,
          });
        }
        return temArr;
      }
    },
    sortData(header) {
      if (header) {
        if (this.sortKey !== header.value) this.sortDesc = true;
        if (this.sortKey && this.sortDesc && this.sortKey === header.value) {
          this.sortKey = "";
        } else if (this.sortDesc) {
          this.sortKey = header.value;
          this.sortDesc = false;
        } else {
          this.sortKey = header.value;
          this.sortDesc = true;
        }
      }
    },
    resetFilters() {
      this.filterValue = {};
      this.showFilter = [];
      this.selectedFilterItems = {};
      this.sortKey = "";
      if (this.sortByDate) {
        this.sortKey = 'created_at'
      }
      this.headerFilter();
      this.$emit('update:filters', {});
    },
    select() {
      if (this.selectAll) {
        const uniqueItems = [...new Set(this.finalItems?.map(item => item[this.multiselectkey]))];
        this.selectedItem = uniqueItems;
        this.selectItem = uniqueItems;
      } else {
        this.selectedItem = [];
        this.selectItem = [];
      }
      this.$emit('selectItem', this.selectItem)
    },
    addItemToSelect(item) {
      if (this.selectedItem.includes(item[this.multiselectkey])) {
        this.selectedItem = this.selectedItem.filter((el) => el !== item[this.multiselectkey])
      }
      else if (!this.selectedItem.includes(item[this.multiselectkey])) {
        this.selectedItem = [...this.selectedItem, item[this.multiselectkey]]
      }
      this.selectItem = [...this.selectedItem]
      this.$emit('selectItem', this.selectItem)
    },
    loadNextPageCheckbox() {
      this.selectItem = [...this.selectedItem]
      // In server-side mode, emit page change so parent can fetch the new page
      if (this.serverSidePagination) {
        // Skip emit when the page change was driven by the parent's currentPage prop sync
        // to avoid duplicate fetches (e.g., parent resets currentPage on filter change).
        if (this._isPageSyncing) return;
        // page is 1-based internally; convert to 0-based for the API
        this.$emit('loadNextPage', { page: this.page - 1 });
      }
    },
    removeAllSelect() {
      if (this.selectItem.length === this.finalItems.length) this.selectAll = true;
      else this.selectAll = false;
    },
    setHeader(d){
        this.selectedHeader = d;
    },
    /**
     * Returns the style object for a column based on header configuration
     * @param {Object} header - The header configuration object
     * @returns {Object} Style object with width and whitespace properties
     */
    getColumnStyle(header) {
      const style = {
      };
      if (header.width) {
        style.width = typeof header.width === 'number' ? `${header.width}px` : header.width;
        style.minWidth = style.width;
        style.maxWidth = style.width;
      } else {
        style.whiteSpace = 'nowrap';
      }
      return style;
    }
  },
  watch: {
    headers: {
      handler() {
        this.populateVisible();
      },
      deep: true,
      immediate: true
    },
    loading(d) {
      if (d === false) {
        // this.resetFilters();
        this.selectAll = false;
        this.selectItem = [];
        this.selectedItem= [];
      }
    },
    items: {
      handler() {
        this.headerFilter();
      },
      deep: true,
      immediate: true
    },
    /**
     * Sync internal page when the parent updates currentPage (server-side pagination).
     * currentPage is 0-based; internal page is 1-based.
     */
    currentPage: {
      handler(newVal) {
        if (this.serverSidePagination) {
          const target = (newVal || 0) + 1;
          if (this.page !== target) {
            // Flag that the page change is prop-driven so loadNextPageCheckbox
            // won't emit a duplicate loadNextPage event.
            this._isPageSyncing = true;
            this.page = target;
            this.$nextTick(() => {
              this._isPageSyncing = false;
            });
          }
        }
      },
      immediate: true
    },
    /**
     * Update pagecount reactively when the server reports a new total.
     * This is the ONLY place pagecount is set in server-side mode — computed
     * properties must NOT call storeTotal() to avoid overriding this value.
     */
    serverTotalCount: {
      handler(newVal) {
        if (this.serverSidePagination) {
          const count = Number(newVal) || 0;
          this.total = count;
          this.pagecount = Math.ceil(count / this.perpage) || 1;
        }
      },
      immediate: true
    },
    /**
     * When page size (perpage) changes in server-side mode, recompute pagecount
     * from the current server total so pagination stays accurate.
     */
    perpage: {
      handler(newVal) {
        if (this.serverSidePagination) {
          const per = Number(newVal) || 1;
          const total = Number(this.serverTotalCount) || 0;
          this.total = total;
          this.pagecount = Math.max(1, Math.ceil(total / per));
          // Clamp current page to new pagecount bounds
          if (this.page > this.pagecount) {
            this.page = this.pagecount;
          }
        }
      }
    },

  },
};
</script>
<style scoped>
.scroll {
  overflow-y: auto;
  max-height: 250px;
  width: 280px;
}
.cursor-pointer {
  cursor: pointer;
}
.datatable-new {
  max-height: 766px;
  overflow-y: auto;
}
</style>